export const languageMap = {
    'hebrew': {
        lang: "he",
        dir: "rtl",
        title: "HE",
        hubspotId: process.env.REACT_APP_HUBSPOT_ID_HE
    },
    'english': {
        lang: "en",
        dir: "ltr",
        title: "EN",
        hubspotId: process.env.REACT_APP_HUBSPOT_ID_EN
    }
}